import { render, staticRenderFns } from "./BatchReportSummary.vue?vue&type=template&id=10cd540a&"
import script from "./BatchReportSummary.vue?vue&type=script&lang=js&"
export * from "./BatchReportSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cd540a')) {
      api.createRecord('10cd540a', component.options)
    } else {
      api.reload('10cd540a', component.options)
    }
    module.hot.accept("./BatchReportSummary.vue?vue&type=template&id=10cd540a&", function () {
      api.rerender('10cd540a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/BatchReport/BatchReportSummary.vue"
export default component.exports